module.exports = __webpack_public_path__ + "img/loading.b5cf1c34.gif";